export const els = {
  firstText: "¡LO SENTIMOS!",
  secondText: "La página que buscas no esta disponible.",
};
